import PropTypes from 'prop-types';
import React from 'react';
import dividerSize from './config';
import StyledDivider from './styled-divider';

const { forwardRef } = React;

const propTypes = {
	color: PropTypes.string,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
	tag: PropTypes.string,
};

const defaultProps = {
	color: undefined,
	className: undefined,
	dataTestId: undefined,
	size: undefined,
	tag: undefined,
};

const Divider = forwardRef(({ color, className, dataTestId, size, tag, ...rest }, ref) => (
	<StyledDivider
		as={tag}
		color={color || 'var(--color-functional-divider)'}
		className={className}
		data-testid={dataTestId || 'fuse-divider'}
		ref={ref}
		size={dividerSize[size] || dividerSize.xs}
		{...rest}
	/>
));

Divider.propTypes = propTypes;
Divider.defaultProps = defaultProps;

export default Divider;
export { Divider, dividerSize };
